import * as Bridge from "@mail/master-jssdk";
import { catchError } from "../tools";
import { Toast } from "antd-mobile";
import Base from "./Base";

function errorHandle(e: Error, msg: string) {
  console.error({
    content: `${e.message}${msg}`
  });
  window.Tongji.data('bridge_call_fail', {
    message: e.message,
    info: msg
  })
}

export default class ActivityBridge extends Base{
  private bridge: typeof Bridge;
  constructor() {
    super();
    this.bridge = Bridge;
  }

  public async isMaster() {
    try {
      return await this.bridge.isMailMaster();
    } catch (e) {
      return false;
    }
  }

  @catchError("发送短信异常", errorHandle)
  public async sendSms(options: Bridge.SendSmsMessage) {
    await this.bridge.sendSms(options);
  }

  @catchError("打开浏览器失败",errorHandle)
  public async openUrlInBrowser(options: Bridge.OpenUrlInBrowserMessage) {
    await this.bridge.openUrlInBrowser(options);
  }
  @catchError("分享失败", errorHandle)
  public async share(options: Bridge.ShareMessage) {
    
    try {
      window.Tongji.data('activity_share_start', options);
      let delegate =  this.bridge.shareOnCompletion((res) => { 
        delegate.abort();
        const key = res?.ok ? 'activity_share_ok' : 'activity_share_fail'
        window.Tongji.data(key, options);
       })  
    } catch (error) {
      
    }
    await this.bridge.share(options);
  }

  @catchError("预置分享信息失败", errorHandle)
  public async prepareShare(options: any) {
    await this.bridge.prepareShare(() => options);
  }
  @catchError("读取剪贴板文本失败", errorHandle)
  public async readClipbroadText() {
    return await this.bridge.readTextFromClipboard();
  }
  @catchError("摇一摇监听", errorHandle)
  public async shakeComplete(callback: Function) {
    await this.bridge.shake(callback as any);
  }
  @catchError("获取sim卡", errorHandle)
  public async getSIMInfo() {
    return await this.bridge.getSimInfo();
  }
  @catchError("获取客户端信息", errorHandle)
  public async getClientInfo() {
    return await this.bridge.getClientInfo();
  }
  @catchError("打开系统设置", errorHandle)
  public async openSetting() {
    await this.bridge.openSettings();
  }
  @catchError("查看邮件", errorHandle)
  public async readMailList(options?: Bridge.ReadMailMessage) {
    await this.bridge.readMail(options);
  }
  @catchError("写邮件", errorHandle)
  public async writeMail(options?: Bridge.WriteMailMessage) {
    await this.bridge.writeMail(options);
  }
  @catchError("屏幕信息", errorHandle)
  public async getScreenInfo() {
    return await this.bridge.getScreenInfo();
  }
  @catchError("设备信息", errorHandle)
  public async getDeviceInfo() {
    return await this.bridge.getDeviceInfo();
  }
  @catchError("设备信息", errorHandle)
  public async notify(options: Bridge.NotificationMessage) {
    await this.bridge.notification(options);
  }
  @catchError("页面即将离开", errorHandle)
  public async PageWillLeave(callback: () => void) {
    await this.bridge.pageWillLeave(callback);
  }
  @catchError("设置页面配置", errorHandle)
  public async setPageOptions(options: Bridge.SetPageOptionsMessage) {
    await this.bridge.setPageOptions(options);
  }
  @catchError("关闭当前页面", errorHandle)
  public async closePage() {
    await this.bridge.navigateBack();
  }
  @catchError("关闭当前页面并跳转",errorHandle)
  public async redirectTo(options: Bridge.RedirectToMessage) {
    await this.bridge.redirectTo(options);
  }
  @catchError("打开浮层webview", errorHandle)
  public async presentToOverlay(options: Bridge.PresentToOverlayMessage) {
    await this.bridge.presentToOverlay(options);
  }
  @catchError("关闭当前页面并跳转", errorHandle)
  public async dismissFromOverlay(options: Bridge.DismissFromOverlayMessage) {
    await this.bridge.dismissFromOverlay(options);
  }
  @catchError("展示Toast弹窗", errorHandle)
  public async showToast(options: Bridge.ShowToastMessage) {
    await this.bridge.showToast(options);
  }
  @catchError("展示loading弹窗", errorHandle)
  public async showLoaidng(options: Bridge.ShowLoadingMessage) {
    await this.bridge.showLoading(options);
  }
  @catchError("展示loading弹窗", errorHandle)
  public async hideLoading() {
    await this.bridge.hideLoading();
  }
  @catchError("获取联系人列表", errorHandle)
  public async getContactList(options?: Bridge.GetContactListMessage) {
    return await this.bridge.getContactList(options);
  }
  @catchError("添加邮箱账号", errorHandle)
  public async addAccount(options?: Bridge.AddAccountMessage) {
    await this.bridge.addAccount(options);
  }
  @catchError("登录邮箱", errorHandle)
  public async loginAccount(options?: Bridge.LoginAccountMessage) {
    await this.bridge.loginAccount(options);
  }
  @catchError("绑定安全手机", errorHandle)
  public async bindAccountPhone(options?: Bridge.BindAccountPhoneMessage) {
    return await this.bridge.bindAccountPhone(options);
  }
  @catchError("获取大师账号信息", errorHandle)
  public async getMasterInfo() {
    return await this.bridge.getMasterUserInfo();
  }
  @catchError("通知客户端大师号已失效", errorHandle)
  public async invalidMasterSession() {
    await this.bridge.invalidMasterSession();
  }
  @catchError("登录大师号", errorHandle)
  public async loginMaster(options?: any) {
    return await this.bridge.loginMaster(options);
  }
  @catchError("页面focus", errorHandle)
  public async pageDidFocus(options?: any) {
    return await this.bridge.pageDidFocus(options);
  }
  @catchError("退出大师号", errorHandle)
  public async logoutMaster() {
    await this.bridge.logoutMaster();
  }
  @catchError("大师是否登录", errorHandle)
  public async isMasterLogin() {
    return await this.bridge.validateMasterSession();
  }
  @catchError("获取邮箱账号列表")
  public async getAccounts() {
    return this.bridge.getAccountList();
  }
  @catchError("navigateTo 跳转")
  public async navigateTo(options: Bridge.NavigateToMessage) {
    await this.bridge.navigateTo(options);
  }

  @catchError("原生支付")
  public static async pay(params?: any) {
    return await Bridge.pay(params);
  }
  
}
